<button
  pButton
  [text]="true"
  [plain]="!direction"
  size="small"
  [icon]="icon"
  [disabled]="loading"
  (click)="handleButtonClicked()"
  ></button>
